export const ClientLogoCard = ({ logo, className = "" }) => (
  <div
    data-testid={`client-logo-${logo.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
    className={`aspect-[3/2] rounded-xl border border-navy/10 bg-white flex items-center justify-center p-5 grayscale opacity-80 hover:grayscale-0 hover:opacity-100 hover:border-accent/30 hover:-translate-y-1 transition-all duration-300 ${className}`}
    title={logo.name}
  >
    <img src={logo.file} alt={`${logo.name} logo`} loading="lazy" className="max-h-full max-w-full object-contain" />
  </div>
);

export const ClientLogos = ({ logos }) => (
  <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-5 gap-4">
    {logos.map((logo) => (
      <ClientLogoCard key={logo.name} logo={logo} />
    ))}
  </div>
);
